<template>

<com-item name="players.activity" :size="size" :loading="loading" title="New & Returning">

	<template v-slot:stats>

		<app-visualisation-bars :data="graph" v-on:click="onSectionClick" />

	</template>

	<template v-slot:buttons>

		<com-key :data="key" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comKey from './../common/Key'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-key': comKey
	},

	data: function() {
	
		return {
			key: [
				{ color: '#3bce5a', label: 'New players' },
				{ color: '#8FC0D4', label: 'Returning players' }
			]
		}
	
	},

	computed: {

		graph: function() {

			return {
				datasets: [
					{ type: 'bar', data: [], yAxis: 'left', backgroundColor: '#3bce5a', tooltip: '{{value}} <small>New player{{value.plural}}</small>' },
					{ type: 'bar', data: [], yAxis: 'left', backgroundColor: '#8FC0D4', tooltip: '{{value}} <small>Returning player{{value.plural}}</small>' },
				],
				axis: {
					x: {
						action: 'click',
						labels: [],
						type: (this.period === 'all') ? 'year' : 'month'
					},
					y: {
						left: {
							type: 'scale',
							min: 10,
							points: 5
						}
					}
				}
			}

		},

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/activity']

		},

		active: function() {

			return this.$_.keys(this.data).length && !this.loading

		},

		period: function() {

			return this.$store.getters['filter/insights/players/period']

		}

	},

	created: function() {

		this.visualise()	

	},

	watch: {

		activity: function() {

			this.visualise()

		}

	},

	methods: {

		onSectionClick: function(value) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersActivity',
				band: value,
				period: this.data[value].period
			})

		},

		visualise: function() {

			if (this.$_.keys(this.data).length) {

				this.graph.axis.x.labels = []
				this.graph.datasets[0].data = []
				this.graph.datasets[1].data = []

				this.$_.each(this.data, function(activity) {

					this.graph.axis.x.labels.push(activity.label)
					this.graph.datasets[0].data.push(activity.new)
					this.graph.datasets[1].data.push(activity.returning)

				}.bind(this))

			}

		}

	}

}

</script>

<style scoped>

</style>